import { getApiClientErrorBody, getApiClientErrorStatus } from '@/services/api/errors';

const GENERIC_SIGNUP_ERROR = 'Sign up failed. Try again or contact support if the issue continues.';

function errorDetails(error: unknown): string[] {
  const body = getApiClientErrorBody(error);
  // oxlint-disable-next-line typescript/consistent-type-assertions -- pre-existing assertion; replace with narrowing when touched
  const errors = (body as { errors?: Array<{ detail?: unknown }> } | undefined)?.errors;
  if (!Array.isArray(errors)) {
    return [];
  }
  return errors.map((entry) => entry?.detail).filter((detail): detail is string => typeof detail === 'string');
}

/**
 * Map a failed register call to user-facing copy.
 *
 * The promo branch matters most: the funnel sends the raw URL promo code to
 * the promo endpoint (the server is the authority — pre-validation only drives
 * the banner), so an unknown (404) or already-redeemed (409) code fails the
 * register and the visitor needs to be told the *promo* is the problem, not
 * signup itself.
 */
export function resolveSignupErrorMessage(error: unknown, promoCode?: string): string {
  const details = errorDetails(error);

  // The Snackbar content guidelines require complete sentences, so these
  // deliberately add terminal periods the historical copy lacked.
  if (details.includes('first_name can not contain a url')) {
    return 'First name cannot contain a URL.';
  }

  if (details.includes('last_name can not contain a url')) {
    return 'Last name cannot contain a URL.';
  }

  const status = getApiClientErrorStatus(error);
  if (promoCode != null && promoCode !== '' && (status === 404 || status === 409)) {
    return 'That promo code is invalid or has already been used.';
  }

  return GENERIC_SIGNUP_ERROR;
}
